<template>
  <div class="Square">
    <div class="Square__Pic cursor-pointer">
      <div class="Square__Placeholder">
        <div class="Placholder"><div class="PlaceholderActivity"></div></div>
      </div>
    </div>
    <div class="Square__Text leading-tight py-2 text-sm text-gray-500">
      <div class="Square__TextPlaceholder">
        <div class="w-full overflow-hidden relative">
          <div class="Placeholder"><div class="PlaceholderActivity"></div></div>
        </div>
        <div class="w-3/4 overflow-hidden relative">
          <div class="Placeholder"><div class="PlaceholderActivity"></div></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
};
</script>

<style lang="scss" scoped></style>
